import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useState } from "react";
import { MOTIVOS_PERDIDO } from "@/lib/stages";

export function MotivoPerdidoModal({ open, onClose, onConfirm, contactName }) {
  const [motivo, setMotivo] = useState("Não respondeu");
  const [outro, setOutro] = useState("");

  const confirm = () => {
    const final = motivo === "Outro" ? (outro.trim() || "Outro") : motivo;
    onConfirm(final);
    setMotivo("Não respondeu");
    setOutro("");
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="motivo-modal">
        <DialogHeader>
          <DialogTitle className="text-zinc-100 text-base font-semibold">
            Por que não converteu? {contactName && <span className="text-zinc-500 font-normal">— {contactName}</span>}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          {MOTIVOS_PERDIDO.map((m) => (
            <label key={m} className={`flex items-center gap-2 px-3 py-2 rounded-md cursor-pointer border ${motivo === m ? "border-amber-500 bg-amber-500/10" : "border-zinc-800 hover:border-zinc-700"}`}>
              <input type="radio" name="motivo" value={m} checked={motivo === m} onChange={() => setMotivo(m)} data-testid={`motivo-${m}`} className="accent-amber-500" />
              <span className="text-sm text-zinc-200">{m}</span>
            </label>
          ))}
          {motivo === "Outro" && (
            <div className="pt-1">
              <Label className="text-xs">Descreva</Label>
              <Input value={outro} onChange={(e) => setOutro(e.target.value)} className="h-8 text-xs" placeholder="Motivo..." data-testid="motivo-outro" />
            </div>
          )}
          <div className="flex gap-2 pt-2">
            <Button onClick={onClose} className="flex-1 bg-zinc-800 hover:bg-zinc-700 h-8 text-xs">Cancelar</Button>
            <Button onClick={confirm} data-testid="motivo-confirm" className="flex-1 bg-amber-500 hover:bg-amber-600 text-zinc-950 h-8 text-xs font-semibold">Confirmar</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
